import React, { PropTypes } from "react";
import classNames from "classnames";
import { FormattedMessage } from "react-intl";

const ClientSectionSelector = ({
  setSectionKey,
  currentSectionKey,
  disableNavigation = false,
  revealErrors,
  submitErrorsBySection,
  sections,
}) => {
  const makeSectionSelectionHandler = (key) => (event) => {
    event.preventDefault();
    !disableNavigation ? setSectionKey(key) : revealErrors();
  };

  const isSelected = (key) => key === currentSectionKey;

  const sectionHasSubmitError = (section) =>
    !!submitErrorsBySection[section.value].errors;

  const renderSectionMenuItem = (section) => {
    const key = section.value;
    const classes = classNames({
      SectionLink: true,
      active: isSelected(key),
      "has-error": sectionHasSubmitError(section),
    });
    return (
      <li key={key} onClick={makeSectionSelectionHandler(key)}>
        <a className={classes}>{<FormattedMessage id={section.name} />}</a>
      </li>
    );
  };

  return (
    <div className="sub-nav">
      <ul>{Object.values(sections).map(renderSectionMenuItem)}</ul>
    </div>
  );
};

ClientSectionSelector.propTypes = {
  setSectionKey: PropTypes.func,
  currentSectionKey: PropTypes.string,
  disableNavigation: PropTypes.bool,
  revealErrors: PropTypes.func,
  submitErrorsBySection: PropTypes.object,
  sections: PropTypes.object,
};

export default ClientSectionSelector;



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client-form/ClientSectionSelector.js